/**
 * The app's own launcher icon (the gold glass and star), wherever the site offers the app
 * (USER 2026-11-03). A reader who has seen it here knows what to look for in the store and on
 * the home screen afterwards. Decorative: the link around it always names the app in words.
 */
export function AppIcon({ size = 20, className }: { size?: number; className?: string }) {
  return (
    <img
      className={className ? `app-icon ${className}` : "app-icon"}
      src={size > 28 ? "/app-icon-144.png" : "/app-icon-64.png"}
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      decoding="async"
      draggable={false}
    />
  );
}
